import ManageCustomPermissionsView from "./components/ManageCustomPermissionsView";
import { ManageCustomPermissionsLandingProvider } from "./ManageCustomPermissionsLanding.context";
import { useManageCustomPermissionsLandingController } from "./hooks/useManageCustomPermissionsLandingController";

const ManageCustomPermissionsLandingPage = () => {
  const contextValue = useManageCustomPermissionsLandingController();

  return (
    <ManageCustomPermissionsLandingProvider value={contextValue}>
      <ManageCustomPermissionsView />
    </ManageCustomPermissionsLandingProvider>
  );
};

export default ManageCustomPermissionsLandingPage;
